module.exports = __webpack_public_path__ + "img/69.343efb50.png";